export default __webpack_public_path__ + "static/media/menu_open.d9a469c8.svg";